export enum AlertRuleName {
  DEVICE_OFFLINE = 'DeviceOffline',
  DEW_POINT = 'DewPoint',
  HIGH_CURRENT = 'HighCurrent',
  HIGH_HUMIDITY = 'HighHumidity',
  HIGH_PRESSURE = 'HighPressure',
  HIGH_TEMPERATURE = 'HighTemperature',
  HIGH_VOLTAGE = 'HighVoltage',
  LOW_BATTERY = 'LowBattery',
  LOW_HUMIDITY = 'LowHumidity',
  LOW_PRESSURE = 'LowPressure',
  LOW_SIGNAL = 'LowSignal',
  LOW_TEMPERATURE = 'LowTemperature',
  LOW_VOLTAGE = 'LowVoltage',
  NO_VOLTAGE = 'NoVoltage',
  OVERLOADED_CURRENT = 'OverloadedCurrent',
  SHORT_CIRCUIT = 'ShortCircuit',
  CONDENSTATION_RISK_INTAKE = 'CondensationRiskIntake',
  CONDENSATION_RISK_EXHAUST = 'CondensationRiskExhaust',
  EXHAUST_AIR_TOO_COLD = 'ExhaustAirTooCold',
  EXHAUST_AIR_TOO_HOT = 'ExhaustAirTooHot',
  HEATING_WHILE_VALVE_CLOSED = 'HeatingWhileValveClosed',
  NO_HEATING = 'NoHeating',
  TARGET_TEMPERATURE_NOT_REACHED = 'TargetTemperatureNotReached',
  RAPID_TEMPERATURE_DROP = 'RapidTemperatureDrop',
  RAPID_TEMPERATURE_RISE = 'RapidTemperatureRise',
  WEAK_SIGNAL = 'WeakSignal',
  UNKNOWN = 'Unknown'
}
